import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TicketRequestedList.html?raw';

class TicketRequestedList extends compose(_WidgetBaseSP) {
    templateString: any = template;
    ticketList;

    ticketsRequestList: HTMLTableElement;

    getListData(entityId) {
        var url = window.appRoot + "TicketFinder/GetMyRequestedTickets";
        this.StandbyStart();
        let data = { bookingId: entityId };
        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, this._onGetMyRequestedTicketstResponse),
            lang.hitch(this, this._onGetMyRequestedTicketsError),
            false // sync
        );
    }

    _onGetMyRequestedTicketstResponse(response: any) {
        this.StandbyStop();
        this.setListdata(response);
    }

    _onGetMyRequestedTicketsError(err: more.requestErrorMessage) {
        console.log(err);
        alert("ERROR beim GetMyRequestedTickets: " + err.Message);
    }

    setListdata(list) {
        this.ticketList = list;
        let self = this;

        if (this.ticketList.length > 0) {
            this.ticketList.forEach(function (row) {
                //let tr = self.UiModder.domConstruct.create("tr");
                let tr = self.ticketsRequestList.insertRow();
                let colorString;
                if (row.ref_vt_ticket_status.coloration.BackColor.IsNull == false) {
                    colorString = "background-color:" + row.ref_vt_ticket_status.coloration.BackColor.Hex + ";"
                }

                if (row.ref_vt_ticket_status.coloration.TextColor.IsNull == false) {
                    colorString = colorString + "color:" + row.ref_vt_ticket_status.coloration.TextColor.Hex + ";"
                }

                self.UiModder.domConstruct.create('td', {
                    "innerHTML": row.ref_vt_ticket_status.code,
                    style: colorString
                }, tr)
                self.UiModder.domConstruct.create('td', {
                    "innerHTML": row.c_address_1
                }, tr)
                self.UiModder.domConstruct.create('td', {
                    "innerHTML": row.c_address_2
                }, tr)
                self.UiModder.domConstruct.create('td', {
                    "innerHTML": row.tickets_applied
                }, tr)
                self.UiModder.domConstruct.create('td', {
                    "innerHTML": row.note,
                    "nowrap": ""
                }, tr)
                //self.UiModder.domConstruct.place(tr, self.audienceSeatingLayoutsList);
            })
        } else {
            let tr = self.ticketsRequestList.insertRow();
            self.UiModder.domConstruct.create('td', {
                "innerHTML": 'Keine Anfragen vorhanden!',
                "className": "w3-dark-grey",
                "colspan": "5"
            }, tr)
        }
    }
    
    //----------------------- LC -------------------------start
    postCreate(): void {
        let self: any = this;
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        let self: any = this;
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TicketRequestedList);